import { defineMessages } from "./define.js";

/** Words that belong to no one screen: buttons, states, the shell itself. */
export const common = defineMessages("common", {
  appName: { ru: "Vmeste", en: "Vmeste" },
  loading: { ru: "Загрузка", en: "Loading" },
  save: { ru: "Сохранить", en: "Save" },
  /* Подпись под названием свёрнутой формы: одно слово, которое объясняет,
     почему она вообще висит над панелью вкладок. */
  draft: { ru: "Черновик", en: "Draft" },
  /* Жест понятен не всем и доступен не всем — у обеих кнопок есть имя. */
  collapse: { ru: "Свернуть в черновик", en: "Collapse to a draft" },
  expand: { ru: "Развернуть", en: "Open again" },
  cancel: { ru: "Отмена", en: "Cancel" },
  add: { ru: "Добавить", en: "Add" },
  delete: { ru: "Удалить", en: "Delete" },
  edit: { ru: "Изменить", en: "Edit" },
  retry: { ru: "Повторить", en: "Try again" },
  close: { ru: "Закрыть", en: "Close" },
  confirmDelete: { ru: "Точно удалить?", en: "Delete for good?" },
  optional: { ru: "Необязательно", en: "Optional" },
  you: { ru: "Вы", en: "You" },
  allDay: { ru: "весь день", en: "all day" },
  today: { ru: "Сегодня", en: "Today" },
  yesterday: { ru: "Вчера", en: "Yesterday" },
});
